import {REQUEST_ERROR, REQUEST_START, REQUEST_SUCCESS} from "../../../middlewares/api/actions";
import {
  CODELIST_ORDER_ANNOTATION_KEY,
  getArtefactFromSdmxJsonStructure,
  getHCLHierarchyFromSdmxJsonFactory,
  getItemSchemeFromSdmxJsonFactory,
  getNodesFromSdmxJson,
  getSdmxStructuresFromSdmxJson,
  SDMX_JSON_CODELIST_ITEMS_KEY,
  SDMX_JSON_HIERARCHICAL_CODELIST_LIST_KEY
} from "../../../utils/sdmxJson";
import {
  HIERARCHICAL_CODELISTS_AGENCIES_READ,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_CHANGE,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_HIDE,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_SHOW,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_SUBMIT,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DELETE,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_CHANGE,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_HIDE,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_READ,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_EDIT,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_UPDATE_SUBMIT,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_CHANGE,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_HIDE,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_SHOW,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_CHANGE,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_HIDE,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_REPORT_HIDE,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_SHOW,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_SUBMIT,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_LIST_SHOW,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_PARENTS_AND_CHILDREN_HIDE,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_PARENTS_AND_CHILDREN_READ,
  HIERARCHICAL_CODELISTS_LIST_HIERARCHICAL_CODELISTS_READ,
  HIERARCHICAL_CODELISTS_SELECTED_HIERARCHICAL_CODELISTS_DELETE,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CREATE,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CREATE_SUBMIT,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_READ_INCLUDED_CODELISTS,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_ITEMS_EMPTY,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_READ_CODELISTS_FOR_SELECTION,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_INCLUDED_CODELIST_ADD,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_INCLUDED_CODELISTS_DELETE,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_HIERARCHY_SAVE,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_SET,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_SAVE_SUBMIT
} from "./actions";
import _ from "lodash";
import {getCurrentNodeConfig} from "../../../middlewares/current-node-config/middleware";
import {getCurrentUserPermissions} from "../../../middlewares/current-user-permissions/middleware";
import { isStrCaseInsensitiveEquals } from "../../../utils/annotations";
import { getCodelistTreeNode, getUniqueIdFromAlias } from "./utils";
import { reuseInReducer, reuseReducer } from "../../../utils/reduxReuse";
import codelistDetailModalReducer from "../../../redux-components/redux-codelist-detail-modal/reducer";

const hierarchicalCodelistsReducer = (
  state = {
    hierarchicalCodelists: null,
    isDetailVisible: false,
    hierarchicalCodelistTriplet: null,
    hierarchicalCodelist: null,
    agencies: null,
    allAgencies: null,
    downloadHierarchicalCodelistTriplets: null,
    downloadHierarchicalCodelistLang: null,
    downloadHierarchicalCodelistParams: null,
    parentsAndChildren: null,
    cloneDestTriplet: null,
    hierarchicalCodelistExportSourceTriplet: null,
    hierarchicalCodelistExportDestination: null,
    hierarchicalCodelistExportReport: null,
    focusItemsTab: false,
    isHierarchicalCodelistGeneralTabDirty:false,
    unsavedChange: false,
    includedCodelistsItemsTree: null,
    codelists: null,
  },
  action
) => {
  switch (action.type) {

    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CREATE:
      return {
        ...state,
        hierarchicalCodelist: {
          id: null,
          agencyID: null,
          version: null,
          isFinal: false,
          uri: null,
          urn: null,
          validTo: null,
          validFrom: null,
          name: null,
          description: null
        },
        isDetailVisible: true,
        hierarchicalCodelistTriplet: null,
        includedCodelistsItemsTree: null,
        codelists: null,
        unsavedChange: false,
      };

    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_EDIT:
      return {
        ...state,
        isDetailVisible: true,
        hierarchicalCodelistTriplet: action.artefactTriplet,
        focusItemsTab: false,
        isHierarchicalCodelistGeneralTabDirty: false,
        unsavedChange: false
      };
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_CHANGE:
      const hierarchicalCodelist = _.cloneDeep(state.hierarchicalCodelist);

      const customizer = (_, src, key) => {
        if (key === "annotations")
          return src;
        else {
          return undefined
        }
      };

      return {
        ...state,
        hierarchicalCodelist: _.mergeWith(hierarchicalCodelist, action.fields, customizer),
        isHierarchicalCodelistGeneralTabDirty: true,
        unsavedChange: true,
      };
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_HIDE:
      return {
        ...state,
        isDetailVisible: false,
        hierarchicalCodelist: null,
        hierarchicalCodelistTriplet: null,
        focusItemsTab: false,
        includedCodelistsItemsTree: null,
        codelists: null,
        unsavedChange: false,
      };
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_SHOW:
      return {
        ...state,
        downloadHierarchicalCodelistTriplets: action.artefactTriplets,
        downloadHierarchicalCodelistLang: action.lang,
        downloadHierarchicalCodelistParams: {
          format: null,
          references: false,
          compression: false,
          csvSeparator: ";",
          csvDelimiter: null,
          csvLanguage: null
        },
      };
      case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_LIST_SHOW:
        return {
          ...state,
          downloadHierarchicalCodelistTriplets: action.artefactTriplets,
          downloadHierarchicalCodelistLang: action.lang,
          downloadHierarchicalCodelistParams: {
            format: "csv",
            hideFormat: true,
            hideLanguage: true,
            references: false,
            compression: false,
            csvSeparator: ";",
            csvDelimiter: null,
            csvLanguage: null
          },
        };
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_HIDE:
      return {
        ...state,
        downloadHierarchicalCodelistTriplets: null,
        downloadHierarchicalCodelistLang: null,
        downloadHierarchicalCodelistParams: null
      };
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_CHANGE:
      const downloadHierarchicalCodelistParams = _.cloneDeep(state.downloadHierarchicalCodelistParams);
      return {
        ...state,
        downloadHierarchicalCodelistParams: _.merge(downloadHierarchicalCodelistParams, action.fields)
      };
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_PARENTS_AND_CHILDREN_HIDE:
      return {
        ...state,
        parentsAndChildren: null
      };
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_SHOW:
      const srcVersionArr = action.srcTriplet.version.split(".");
      const destVersionArr = srcVersionArr.map((num, index) =>
        index === srcVersionArr.length - 1
          ? Number(num) + 1
          : num
      );

      return {
        ...state,
        cloneDestTriplet: {
          ...action.srcTriplet,
          version: destVersionArr.join(".")
        },
        hierarchicalCodelistTriplet: state.hierarchicalCodelistTriplet ? state.hierarchicalCodelistTriplet : action.srcTriplet,
      };
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_HIDE:
      return {
        ...state,
        cloneDestTriplet: null,
        hierarchicalCodelist: state.isDetailVisible ? state.hierarchicalCodelist : null,
        hierarchicalCodelistTriplet: state.isDetailVisible ? state.hierarchicalCodelistTriplet : null,
        includedCodelistsItemsTree: state.isDetailVisible ? state.includedCodelistsItemsTree : null,
      };
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_CHANGE:

      const cloneDestTriplet = _.cloneDeep(state.cloneDestTriplet);

      return {
        ...state,
        cloneDestTriplet: _.merge(cloneDestTriplet, action.fields)
      };
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_SHOW:
      return {
        ...state,
        hierarchicalCodelistExportSourceTriplet: action.sourceTriplet,
        hierarchicalCodelistExportDestination: {
          endpoint: null,
          username: null,
          password: null,
          id: action.sourceTriplet.id,
          agencyID: action.sourceTriplet.agencyID,
          version: action.sourceTriplet.version
        }
      };
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_HIDE:
      return {
        ...state,
        hierarchicalCodelistExportSourceTriplet: null,
        hierarchicalCodelistExportDestination: null,
        // agencies: state.isDetailVisible ? state.agencies : null,
        // allAgencies: state.isDetailVisible ? state.allAgencies : null
      };
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_CHANGE: {

      const hierarchicalCodelistExportDestination = _.cloneDeep(state.hierarchicalCodelistExportDestination);
      _.merge(hierarchicalCodelistExportDestination, action.fields);

      return {
        ...state,
        hierarchicalCodelistExportDestination
      }
    }
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_REPORT_HIDE:
      return {
        ...state,
        hierarchicalCodelistExportReport: null
      };
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_ITEMS_EMPTY:
      return {
        ...state,
        includedCodelistsItemsTree: [],
        codelists: null,
      };   
      
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_INCLUDED_CODELISTS_DELETE: {
        
      let codelistsItemsTree = [...(state.includedCodelistsItemsTree || [])].filter( c => !action.codelists.includes(c.uniqueId)); 
      let hcl  = _.cloneDeep(state.hierarchicalCodelist); 

      action.codelists.forEach(c => {                
        let key = getUniqueIdFromAlias(c);
        delete hcl.includedCodelists[key];
      });  

      return {
        ...state,
        hierarchicalCodelist: hcl,
        includedCodelistsItemsTree: codelistsItemsTree,
        unsavedChange: true      
      };
    }

    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_HIERARCHY_SAVE: {

      const hcl = _.cloneDeep(state.hierarchicalCodelist);
      hcl.hierarchies = hcl.hierarchies || [];

      let hierarchyToSave = action.hierarchy;
      hierarchyToSave.hierarchicalCodes = hierarchyToSave.hierarchicalCodes || [];      
      

      let index = (hcl.hierarchies || []).findIndex(h => h.id === hierarchyToSave.id);

      if (index >= 0) 
      {
        hcl.hierarchies[index] = hierarchyToSave;
      }
      else 
      {
        hierarchyToSave.uniqueId = hierarchyToSave.id;
        hierarchyToSave.codeID = hierarchyToSave.id;
        if (action.pos === -1) {
          hcl.hierarchies.push(hierarchyToSave);
        } else {
          hcl.hierarchies.splice(action.pos, 0, hierarchyToSave);
        }
        
      }
   
      return {
        ...state,
        hierarchicalCodelist: hcl,
        unsavedChange: true,
      };
    }

    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_SET: {
      
      return {
        ...state,
        hierarchicalCodelist: action.hierarchicalCodelist,
        unsavedChange: true,
      };
    }
    
    case REQUEST_START:
    
      switch (action.label) {
          
        case HIERARCHICAL_CODELISTS_LIST_HIERARCHICAL_CODELISTS_READ:
          return {
            ...state,
            hierarchicalCodelists: null,
            includedCodelistsItemsTree: state.isDetailVisible ? 
              state.includedCodelistsItemsTree 
                ? state.includedCodelistsItemsTree : [] : null,
          };
        case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_READ_INCLUDED_CODELISTS:
          return {
            ...state,
            includedCodelistsItemsTree: null,
          };       
        default:
          return state;
      }
        
    case REQUEST_SUCCESS:
      switch (action.label) {

        case HIERARCHICAL_CODELISTS_AGENCIES_READ:
          return {
            ...state,
            agencies: _.pickBy(action.response, (_, agencyID) => !action.allowedAgencies || action.allowedAgencies.includes(agencyID)),
            allAgencies: action.response,
        };
        
        case HIERARCHICAL_CODELISTS_LIST_HIERARCHICAL_CODELISTS_READ:
          return {
            ...state,
            hierarchicalCodelists: getSdmxStructuresFromSdmxJson(action.response).map(artefact =>
              getArtefactFromSdmxJsonStructure(artefact, getCurrentNodeConfig(action).annotations))
          };
        
        case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_READ: {
          
          const userPermissions = getCurrentUserPermissions(action);
          const customNoneIsAutoAnnotation = userPermissions && userPermissions.rules.includes("CanManageWorkingAnnotation")
            ? () => false
            : undefined;
        
          let hcl = getHCLHierarchyFromSdmxJsonFactory(
              getCurrentNodeConfig(action).annotations,
              customNoneIsAutoAnnotation
            )(getSdmxStructuresFromSdmxJson(action.response, SDMX_JSON_HIERARCHICAL_CODELIST_LIST_KEY)[0]);
       
          return {
            ...state,
            hierarchicalCodelist: hcl,
            hierarchicalCodelistTriplet: action.hierarchicalCodelistTriplet,
            includedCodelistsItemsTree: null,
          };
        }
        
        case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CREATE_SUBMIT: {

          return {
            ...state,
            hierarchicalCodelist: null,
            hierarchicalCodelists: null,
            isDetailVisible: true,
            hierarchicalCodelistTriplet: action.hierarchicalCodelistTriplet,
            focusItemsTab: true,
            isHierarchicalCodelistGeneralTabDirty: false,
            unsavedChange: false,
            includedCodelistsItemsTree: null,
          };
        }
                  
        case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_UPDATE_SUBMIT:
          return {
            ...state,
            hierarchicalCodelists: null,
            isHierarchicalCodelistGeneralTabDirty: false,
            unsavedChange: false,
            focusItemsTab: true
          };
        
        case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_SAVE_SUBMIT:
          return {
            ...state,
            isHierarchicalCodelistGeneralTabDirty: false,
            unsavedChange: false,
            focusItemsTab: true
          };
        case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_READ_INCLUDED_CODELISTS: {
           
            const userPermissions = getCurrentUserPermissions(action);
            const annotations = getCurrentNodeConfig(action).annotations;
            const annotation = annotations[CODELIST_ORDER_ANNOTATION_KEY];
            const customNoneIsAutoAnnotation = userPermissions && userPermissions.rules.includes("CanManageWorkingAnnotation")
              ? (ann) => (ann && isStrCaseInsensitiveEquals(ann.type, annotation.type))
              : undefined;
  
              let dictCodes = {};
  
            /************* Creazione albero delle codelists referenziate **************/
           
            let codelistsItemsTree = [];
  
            (action.response || []).forEach(c => {
  
              let codelist = getItemSchemeFromSdmxJsonFactory(
                SDMX_JSON_CODELIST_ITEMS_KEY,
                annotations,
                CODELIST_ORDER_ANNOTATION_KEY,
                customNoneIsAutoAnnotation
              )(getSdmxStructuresFromSdmxJson(c)[0]);

              let includedCodelist = getCodelistTreeNode(codelist, action.childrenKey, dictCodes);
              
              codelistsItemsTree.push(includedCodelist);
  
            });   
            
            /************* Creazione albero della definizione della codelist gerarchica **************/
  
            let hcl = _.cloneDeep(state.hierarchicalCodelist);
            (hcl.hierarchies || []).forEach(h => {
              h.hierarchicalCodes = getNodesFromSdmxJson(h.id, h.hierarchicalCodes, dictCodes);            
            });

            return {
              ...state,
              hierarchicalCodelist: hcl,
              includedCodelistsItemsTree: codelistsItemsTree,
            };
        }

        case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DELETE:
          return {
            ...state,
            hierarchicalCodelists: null
          };
        
        case HIERARCHICAL_CODELISTS_SELECTED_HIERARCHICAL_CODELISTS_DELETE:
          return {
            ...state,
            hierarchicalCodelists: null
        };

        case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD:
          return {
            ...state,
            downloadHierarchicalCodelistTriplets: null,
            downloadHierarchicalCodelistLang: null,
            downloadHierarchicalCodelistParams: null
          };
        case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_PARENTS_AND_CHILDREN_READ:
          return {
            ...state,
            parentsAndChildren: action.response
          };
        case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_SUBMIT:
          return {
            ...state,
            hierarchicalCodelistExportSourceTriplet: null,
            hierarchicalCodelistExportDestination: null,
            hierarchicalCodelistExportReport: action.response.itemsMessage,
            // agencies: state.isDetailVisible ? state.agencies : null,
            // allAgencies: state.isDetailVisible ? state.allAgencies : null
          };
        case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_SUBMIT:
          return {
            ...state,
            hierarchicalCodelists: null,
            cloneDestTriplet: null,
            hierarchicalCodelistTriplet: state.isDetailVisible ? state.hierarchicalCodelistTriplet : null,
            hierarchicalCodelist: state.isDetailVisible ? state.hierarchicalCodelist : null,
            includedCodelistsItemsTree: state.isDetailVisible ? state.includedCodelistsItemsTree : null,
          };
        
        case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_READ_CODELISTS_FOR_SELECTION:
          return {
            ...state,
            codelists:
              (getSdmxStructuresFromSdmxJson(action.response) || [])
                .map(codelist => getArtefactFromSdmxJsonStructure(codelist, getCurrentNodeConfig(action).annotations))
          };
        
        case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_INCLUDED_CODELIST_ADD: {
          const userPermissions = getCurrentUserPermissions(action);
          const annotations = getCurrentNodeConfig(action).annotations;
          const annotation = annotations[CODELIST_ORDER_ANNOTATION_KEY];
          const customNoneIsAutoAnnotation = userPermissions && userPermissions.rules.includes("CanManageWorkingAnnotation")
            ? (ann) => (ann && isStrCaseInsensitiveEquals(ann.type, annotation.type))
            : undefined;

            let codelistsItemsTree = [...(state.includedCodelistsItemsTree || [])];
            let dictCodes = {};

            let codelist = getItemSchemeFromSdmxJsonFactory(
              SDMX_JSON_CODELIST_ITEMS_KEY,
              annotations,
              CODELIST_ORDER_ANNOTATION_KEY,
              customNoneIsAutoAnnotation
            )(getSdmxStructuresFromSdmxJson(action.response)[0]);
  
            let includedCodelist = getCodelistTreeNode(codelist, action.childrenKey, dictCodes);

            codelistsItemsTree.push(includedCodelist);

            let hcl = _.cloneDeep(state.hierarchicalCodelist);
            let key = includedCodelist.codelistAliasRef;
            hcl.includedCodelists[key] = codelist.urn;

            return {
              ...state,
              hierarchicalCodelist: hcl,
              includedCodelistsItemsTree: codelistsItemsTree,
              unsavedChange: true
            };

        }

        default:
          return state;
      }
    
    case REQUEST_ERROR:
      switch (action.label) {
        case HIERARCHICAL_CODELISTS_SELECTED_HIERARCHICAL_CODELISTS_DELETE:
          return {
            ...state,
            hierarchicalCodelists: null
          };
        case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_UPDATE_SUBMIT:
        case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_SAVE_SUBMIT:
          return {
            ...state,
            isHierarchicalCodelistGeneralTabDirty: true,
            unsavedChange: true,
            focusItemsTab: true
          };
        default:
          return state;
      }
    
    default:
      return state;
  }
};

export const HIERARCHICAL_CODELISTS_PREFIX = "HIERARCHICAL_CODELISTS_PREFIX_";

export default reuseInReducer(hierarchicalCodelistsReducer, {
  codelistDetail: reuseReducer(codelistDetailModalReducer, HIERARCHICAL_CODELISTS_PREFIX)
});


